module.exports = __webpack_public_path__ + "static/media/checkoutbg_right_active.72cb8c52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/checkout-navbar/progress-bullet/checkoutbg_right_active.svg
// module id = 698
// module chunks = 0